import { APP_NAME } from '@/lib/brand';
// Helpers compartidos de mapeo de variables de plantillas WhatsApp (índices {{n}} → fuente
// del lead / texto fijo). Extraídos de CommLogicsPage (v1) para reuso en Recetas v2
// (RecipesPage). COPIADOS TAL CUAL — comportamiento idéntico a v1.

export const WA_VARIABLE_SOURCES = [
  { value: 'lead_name', label: 'Nombre del lead' },
  { value: 'lead_property', label: 'Propiedad de interés' },
  { value: 'lead_vendor', label: 'Vendedor asignado' },
  { value: 'lead_phone', label: 'Teléfono del lead' },
  { value: 'lead_email', label: 'Email del lead' },
  { value: 'company_name', label: 'Nombre de la empresa' },
  { value: 'lead_id', label: 'ID del lead' },
  { value: 'custom', label: 'Texto fijo' },
];

export const defaultVariableSource = (index) => {
  if (index === 1) return 'lead_name';
  if (index === 2) return 'lead_property';
  if (index === 3) return 'lead_vendor';
  if (index === 4) return 'lead_phone';
  if (index === 5) return 'lead_email';
  if (index === 6) return 'company_name';
  if (index === 7) return 'lead_id';
  return 'custom';
};

export const extractTemplateIndexes = (body = '') => {
  const text = String(body || '');
  const matches = [...text.matchAll(/\{\{\s*(\d+)\s*\}\}/g)];
  return [...new Set(matches.map((m) => Number(m[1])).filter((n) => Number.isFinite(n) && n > 0))].sort((a, b) => a - b);
};

export const normalizeVariableMapping = (indexes = [], existing = []) => {
  const byIndex = new Map((Array.isArray(existing) ? existing : []).map((m) => [Number(m.index), m]));
  return indexes.map((idx) => {
    const prev = byIndex.get(idx) || {};
    const source = prev.source || defaultVariableSource(idx);
    return {
      index: idx,
      source,
      custom_value: source === 'custom' ? (prev.custom_value || '') : '',
    };
  });
};

export const sourceExample = (source, customValue = '') => {
  if (source === 'lead_name') return 'Juan Pérez';
  if (source === 'lead_property') return 'Torre A · Depto 302';
  if (source === 'lead_vendor') return 'María González';
  if (source === 'lead_phone') return '+52 1 55 1234 5678';
  if (source === 'lead_email') return 'juan@email.com';
  if (source === 'company_name') return `${APP_NAME} Real Estate`;
  if (source === 'lead_id') return 'lead_12345';
  if (source === 'custom') return customValue || 'Texto fijo';
  return '-';
};

export const renderGupshupPreview = (templateBody = '', mapping = []) => {
  let output = String(templateBody || '');
  (Array.isArray(mapping) ? mapping : []).forEach((row) => {
    const idx = Number(row?.index);
    if (!Number.isFinite(idx) || idx <= 0) return;
    const value = sourceExample(row.source, row.custom_value);
    const regex = new RegExp(`\\\\{\\\\{\\\\s*${idx}\\\\s*\\\\}\\\\}`, 'g');
    output = output.replace(regex, value);
  });
  return output;
};
